const IMAGE_SOURCE = /^(https?:|data:|blob:|\/|assets\/)/i;
const IMAGE_EXTENSION = /\.(png|jpe?g|gif|svg|webp|bmp|ico|avif)$/i;

/**
 * ¿El valor es una clase de fuente de iconos y no una imagen?
 *
 * El icono de un menú puede venir como clase ('fa fa-home', 'feather icon-users',
 * 'circle') o como imagen: URL completa, ruta, o el nombre del archivo subido a
 * belivfiles (que conserva su extensión, ej. 'a1b2c3d4.png').
 *
 * @param icon Valor guardado en el menú
 */
export function isIconClass(icon?: string): boolean {
  const value = (icon || '').trim();
  if (!value) return false;
  if (IMAGE_SOURCE.test(value)) return false;
  if (IMAGE_EXTENSION.test(value)) return false;
  return true;
}

/**
 * ¿El valor es una imagen en lugar de una clase de fuente?
 * @param icon Valor guardado en el menú
 */
export function isImageIcon(icon?: string): boolean {
  return !!(icon || '').trim() && !isIconClass(icon);
}

/**
 * Prefijo con el que se guarda un icono elegido del catálogo de lucide.
 *
 * Los iconos de los menús conviven: los que ya estaban son clases de font
 * awesome ('fa fa-home') o de feather ('icon-users'), y no tienen forma de
 * distinguirse de un nombre de lucide ('house') mirando el string. Por eso el
 * selector guarda 'lucide:house': el prefijo es la marca, y cualquier valor
 * sin él sigue tratándose como clase de fuente, igual que antes.
 */
export const LUCIDE_ICON_PREFIX = 'lucide:';

/** ¿El valor es un icono del catálogo de lucide? */
export function isLucideIcon(icon?: string): boolean {
  return (icon || '').trim().startsWith(LUCIDE_ICON_PREFIX);
}

/** Nombre de lucide sin el prefijo ('lucide:house' → 'house') */
export function lucideIconName(icon?: string): string {
  return isLucideIcon(icon) ? (icon || '').trim().slice(LUCIDE_ICON_PREFIX.length) : '';
}
